import {
  userImage,
  userInfo
} from '@/api/user'
// import { resolve } from 'core-js/fn/promise'
const state = {
  form: {
    TITLE_NAME: '',
    DATAV_NAME: ''
  },
  userName: '',

  protoImg: ''
}

const mutations = {
  // 获取 名称 可视化中心的参数
  userInfoStatus(state, form) {
    state.form = form
  },
  userName(state, userName) {
    console.log(userName ,'userNameuserNameuserNameuserNameuserNamestore')
    state.userName = userName
  },
  // 获取图片
  mutationImage(state, protoImg) {
    state.protoImg = protoImg
  }
}
//  在mutations 中不能定义异步函数 定时器之类的
const actions = {
  userInfo(context) {
    return new Promise((resolve, reject) => {
      userInfo(this.getters.token).then(response => {
        if (response.data == null) {
          const froms = {
            TITLE_NAME: '励拓新安智能消防',
            DATAV_NAME: '励拓新安可视化中心'
          }
          context.commit('userInfoStatus', froms)
        } else {
          if (response.data.TITLE_NAME && response.data.DATAV_NAME) {
            context.commit('userInfoStatus', response.data)
          }
        }

        resolve()
      }).catch(err => {
        console.log(err)
        // debugger
      })
    })
  },

  userImage(context) {
    return new Promise((resolve, reject) => {
      userImage(this.getters.token).then(response => {
        if (response.data == null) {
          context.commit('mutationImage', '')
        } else {
          // const imgArr = response.data.split('.com')[1]
          // const newUrl = 'http://img.lituo119.com'
          // const protoImg = newUrl + imgArr
          const protoImg= this.$formatOssImageUrl(response.data)
          if (sessionStorage.getItem('protoImg') !== protoImg) {
            sessionStorage.setItem('protoImg', protoImg)
          }
          context.commit('mutationImage', protoImg)
        }

        resolve()
      }).catch(err => {
        console.log(err)
      })
    })
  }

  // 定义异步函数
}

// const module = {
//   // vuex的模块化
// }

export default {
  namespaced: true,
  state,
  mutations,
  actions

}
